import styled from 'styled-components';

export const BtnLinkStyled = styled.div`
  .theme_standard_btn_link {
    width: fit-content;
    text-align: center;
    font-family: noto_sans_thai_regular, noto_sans_regular;
    font-size: ${({ theme }) => theme.FONT.SIZE.S11};
    cursor: pointer;
    .svg_show {
    }
    .show_label {
      margin-top: 4px;
    }
  }
`;
